import { User } from "../../api/UsersApi";

const hasValue = (value: unknown) =>
  value !== null && value !== undefined && String(value).trim() !== "";

export const isCompareInputCompleted = (user?: User) => {
  if (!user) return false;
  if (!hasValue(user.postalCode)) return false;
  if (!hasValue(user.annualSalary)) return false;
  if (!hasValue(user.birthYear)) return false;
  if (!hasValue(user.childrenCount)) return false;

  const childrenCount = Number(user.childrenCount);
  if (!Number.isInteger(childrenCount) || childrenCount < 0 || childrenCount > 5) {
    return false;
  }

  const childrenColumns = [
    user.childrenColumn1,
    user.childrenColumn2,
    user.childrenColumn3,
    user.childrenColumn4,
    user.childrenColumn5,
  ];

  return childrenColumns.slice(0, childrenCount).every(hasValue);
};
